export default __webpack_public_path__ + "static/3-90ed06593eef6b9f8dafd8b75b61e58e.jpg";